import { Component, input } from '@angular/core';

import { CmsCollection, CmsTaxonomyGeneral } from '@fcom/core-api';

@Component({
  selector: 'cms-list-with-heading',
  templateUrl: './cms-list-with-heading.component.html',
  standalone: false,
})
export class CmsListWithHeadingComponent {
  readonly TAXONOMY = CmsTaxonomyGeneral;

  content = input.required<CmsCollection>();
}
